module.exports = __webpack_public_path__ + "static/media/phone.dce86d13.png";